// 购物主流程路由
export default [
  // { // 404 页面不再配路由
  //     path: '/404',
  //     name: '404',
  //     component: () => import('@/views/error/NotFound.vue').then(r => r.default || r),
  // },
  {
    path: '/register',
    name: 'register',
    meta: {
      pos: 0,
      cnName: '注册账号页',
    },
    component: () => import('@/views/login/register.vue').then((r) => r.default || r),
  },
  {
    path: '/forgotPassword',
    name: 'forgotPassword',
    meta: {
      pos: 0,
      cnName: '忘记密码页',
    },
    component: () => import('@/views/login/forgot-password.vue').then((r) => r.default || r),
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    meta: {
      pos: 0,
      cnName: '重置密码页',
    },
    component: () => import('@/views/login/reset-password.vue').then((r) => r.default || r),
  },
  {
    path: '/goods-list/:id',
    name: 'goodsList',
    meta: {
      pos: 0,
      keepalive: true,
      cnName: '商品列表页',
    },
    component: () => import('@/views/goods-list/GoodsList.vue').then((r) => r.default || r),
  },
  // // 专题页魔方测预览
  {
    path: '/d0ebd8ee8e72423813ecb8481a3ec0af/:id',
    name: 'goodsListPreview',
    meta: {
      pos: 0,
      cnName: '商品列表专题页-魔方预览页',
    },
    component: () => import('@/views/goods-list/GoodsList.vue').then((r) => r.default || r),
  },
  {
    path: '/goods-detail/:id',
    name: 'goodsDetail',
    meta: {
      pos: 0,
      keepalive: false,
      cnName: '商品详情页',
      feature_value_name: 'productdetail_page_recommend',
    },
    component: () => import('@/views/goods-detail/GoodsDetail.vue').then((r) => r.default || r),
  },
  {
    path: '/cart',
    name: 'cart',
    meta: {
      pos: 0,
      cnName: '购物车页',
      feature_value_name: 'cart_recommend',
    },
    component: () => import('@/views/shopping-cart/shopping-cart.vue').then((r) => r.default || r),
  },
  {
    path: '/payment',
    name: 'payment',
    meta: {
      pos: 0,
      cnName: '支付页',
    },
    component: () => import('@/views/checkout/payment.vue').then((r) => r.default || r),
  },
  {
    path: '/paymentSuccess',
    name: 'paymentSuccess',
    meta: {
      pos: 0,
      cnName: '支付成功页',
      requiresAuth: true,
    },
    component: () => import('@/views/checkout/payment-success.vue').then((r) => r.default || r),
  },
  {
    path: '/paymentFailed',
    name: 'paymentFailed',
    meta: {
      pos: 0,
      cnName: '支付失败页',
    },
    component: () => import('@/views/checkout/payment-failed.vue').then((r) => r.default || r),
  },
  {
    path: '/waiting-response',
    name: 'waitingResponse',
    meta: {
      pos: 0,
      cnName: '支付结果等待页',
    },
    component: () => import('@/views/checkout/waiting-response.vue').then((r) => r.default || r),
  },
  {
    path: '/waiting-response-pay-center',
    name: 'WaitingResponsePayCenter',
    meta: {
      pos: 0,
      cnName: '支付中台支付结果等待页',
    },
    component: () =>
      import('@/views/checkout/waiting-response-pay-center.vue').then((r) => r.default || r),
  },
  {
    path: '/result',
    name: 'search',
    meta: {
      pos: 0,
      cnName: '搜索结果页',
      feature_value_name: 'search_recommend',
    },
    component: () => import('@/views/search/search-result.vue').then((r) => r.default || r),
  },
  {
    path: '/track-order',
    name: 'trackOrder',
    meta: {
      pos: 0,
      requiresAuth: true,
      cnName: '订单追踪页',
      feature_value_name: 'track_order_recommend',
    },
    component: () => import('@/views/track-order/track-order.vue').then((r) => r.default || r),
  },
  {
    path: '/coupons',
    name: 'coupon',
    meta: {
      pos: 0,
      cnName: '优惠券列表页',
      feature_value_name: 'get_coupons_recommend',
    },
    component: () => import('@/views/coupon/coupon.vue').then((r) => r.default || r),
  },
  {
    path: '/freeshipping',
    name: 'freeshipping',
    component: () => import('@/views/free-shipping/free-shipping.vue').then((r) => r.default || r),
    meta: {
      cnName: '运费券页',
    },
  },
  {
    path: '/packaging-method',
    name: 'packagingMethod',
    component: () =>
      import('@/views/packagingMethod/packagingMethod.vue').then((r) => r.default || r),
    meta: {
      cnName: '打包方式页',
    },
  },
  {
    path: '/price-difference',
    name: 'priceDifference',
    meta: {
      pos: 0,
      cnName: '补差价页',
    },
    component: () =>
      import('@/views/price-difference/PriceDifference.vue').then((r) => r.default || r),
  },
  {
    path: '/price-difference-payment-successful',
    name: 'priceDifferencePaymentSuccessful',
    meta: {
      pos: 0,
      cnName: '补差价支付成功页',
    },
    component: () =>
      import('@/views/price-difference/price-difference-payment-successful.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: '/price-difference-payment-failed',
    name: 'priceDifferencePaymentFailed',
    meta: {
      pos: 0,
      cnName: '补差价支付失败页',
    },
    component: () =>
      import('@/views/price-difference/price-difference-payment-failed.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: '/question-detail/:id',
    name: 'questionDetail',
    component: () => import('@/views/question/question-detail.vue').then((r) => r.default || r),
    meta: {
      cnName: '问卷详情页',
    },
  },
  {
    path: '/question-break/:id',
    name: 'questionBreak',
    component: () => import('@/views/question/question-break.vue').then((r) => r.default || r),
    meta: {
      cnName: '问卷详情页-终止',
    },
  },
  {
    path: '/question-complete/:id',
    name: 'questionComplete',
    component: () => import('@/views/question/question-complete.vue').then((r) => r.default || r),
    meta: {
      cnName: '问卷详情页-完成',
    },
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/test/index.vue').then((r) => r.default || r),
  },
];
